export default function getEnv(variableName) {
    const getUrl = window.location;
    const baseUrl = getUrl.protocol + "//" + getUrl.host;
    let sufix = '_PROD';
    if (baseUrl.includes('-staging.inhanser.com') ||
        baseUrl.includes('-staging.mojohovo.com')) {
        sufix = '_STAGING';
    } 
    else if(baseUrl.includes('-testing.inhanser.com') ||
            baseUrl.includes('-testing.mojohovo.com')||
            baseUrl.includes('http://localhost:3')) {
        sufix = '_TESTING';
    }
    else if(baseUrl.includes('-uat.inhanser.com') ||
            baseUrl.includes('-uat.mojohovo.com')) {
        sufix = '_UAT';
    }
    variableName = `${variableName}${sufix}`;
    return process.env[variableName];
}